<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div>
        <div v-if="loading">
          <Loading></Loading>
        </div>
        <div v-else-if="loadingPristine" class="contact-container">
          <div class="heading-container">
            <div class="font-secondary heading">Contact us!</div>
          </div>
          <div class="each-row">
            <div class="left-side">Name</div>
            <div class="right-side">
              <input class="input-box" v-model="name" placeholder="Name Goes here">
              <span class="error" v-show="errors.name">*Required Field</span>
            </div>
          </div>
          <div class="each-row">
            <div class="left-side">Email</div>
            <div class="right-side">
              <input class="input-box" v-model="email" placeholder="Email Address">
              <span class="error" v-show="errors.email">*Required Field</span>
            </div>
          </div>
          <div class="each-row">
            <div class="left-side">Subject</div>
            <div class="right-side">
              <Dropdown :selection=subject>
                <div class="option" v-for="subject in subjects" @click="setSubject(subject)">{{subject}}</div>
              </Dropdown>
            </div>
          </div>
          <div class="each-row">
            <div class="left-side">Body</div>
            <div class="right-side">
              <label>
                <textarea class="textarea-box" rows="10" v-model="body" placeholder="Message"></textarea>
              </label>
              <span class="error" v-show="errors.body">*Required Field</span>
            </div>
          </div>
          <div class="each-row">
            <div class="left-side"></div>
            <div class="right-side">
              <button class="button pure-button bigmi-red-2-button" v-on:click="sendContactForm">Send</button>
            </div>
          </div>
        </div>
        <div v-else-if="loadingComplete" class="contact-container">
          <ErrorPage class="center-error-page">
            <div slot="header">Thank You</div>
            <div slot="message">Thank you for contacting us. We will be in touch with you shortly.</div>
          </ErrorPage>
        </div>
        <div v-else-if="loadingFailed" class="contact-container">
          <ErrorPage class="center-error-page">
            <div slot="header">Error</div>
            <div slot="message">Message not sent.  Please try again.</div>
          </ErrorPage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Dropdown from "../general/Dropdown"
    import http from "../../services/axios"
    import {
      GET_BACKEND_URL, LOADING_COMPLETED_FAILURE,
      LOADING_COMPLETED_SUCCESS,
      LOADING_PRISTINE,
      LOADING_STARTED
    } from "../../services/constants"
    import ErrorPage from "./ErrorPage"

    export default {
        name: "Contact",
      components: {
        ErrorPage,
        Dropdown,
      },

      data(){
          return{
            name: '',
            email: '',
            subject: 'General Inquiry',
            body: '',
            errors: {
              name: false,
              email: false,
              body: false,
            },
            loadingStatus: LOADING_PRISTINE
          }
      },

      computed:{
        subjects(){
          return ['General Inquiry', 'Technical Support']
        },
        loadingPristine(){
          return this.loadingStatus === LOADING_PRISTINE
        },
        loading(){
          return this.loadingStatus === LOADING_STARTED
        },
        loadingComplete(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
      },

      methods:{
        setSubject(evt){
          this.subject = evt
        },

        sendContactForm(){
          this.resetErrors()
          let readyToSend = this.isFormComplete()
          if (readyToSend){
            this.loadingStatus = LOADING_STARTED
            let contactObject = this.buildContactObject()
            http.post(this.$store.getters[GET_BACKEND_URL](`mail/contact`), contactObject).then(response => {
              this.loadingStatus = LOADING_COMPLETED_SUCCESS
              console.log(response)
            }).catch(err => {
              console.error(err)
              this.loadingStatus = LOADING_COMPLETED_FAILURE
            })
          }
        },

        resetErrors(){
          this.errors = {
            name: false,
            email: false,
            body: false,
          }
        },

        isFormComplete(){
          if (this.name === ''){
            this.errors.name = true
          }
          if (this.email === ''){
            this.errors.email = true
          }
          if (this.body === ''){
            this.errors.body = true
          }
          let readyToSend = Object.keys(this.errors).every(k => !this.errors[k])
          return readyToSend
        },

        buildContactObject(){
          return {
            name: this.name,
            email: this.email,
            subject: this.subject,
            body: this.body,
          }
        }
      }

    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .heading{
    color: $red-2;
    font-size: 20px;
    font-weight: 900;
  }

  .contact-container{
    padding: 3% 5%;
    width: 140%;
  }

  .heading-container{
    padding: 3% 0;
  }

  .left-side{
    display: inline-block;
    vertical-align: top;
    width: 10%;
  }

  .right-side{
    display: inline-block;
    width: 30%;
  }

  .button{
    float: right;
  }

  .input-box{
    width: 100%;
    border: $gray-1;
    height: 40px;
    background-color: $gray-1;
    text-indent:10px;
  }

  .textarea-box{
    width: calc(100% - 10px);
    border: $gray-1;
    background-color: $gray-1;
    padding-top: 10px;
    padding-left: 10px;
    line-height: 1em; // this probably doesn't matter
  }

  .each-row{
    padding: 5px 0;
  }

  .footer-bar {
    width: 100%;
  }
  .inner-footer {
    display:inline-block;
    width: 100%;
    height: 2px;
    background-color: $gray-2;
  }

  .checkbox{
    display: inline-block;
    padding: 0 5px;
  }

  .error{
    color: red;
  }

  .option {
    padding: 5px 20px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .option:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .center-error-page{
    margin: auto;
  }

</style>
